import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { freeSet } from "@coreui/icons";
import { ToastService } from "angular-toastify";
import { isNil } from "lodash-es";
import { Editor, Validators } from "ngx-editor";
import { ApiService } from "src/app/api/api.service";
import { CoreService } from "src/app/services/core-service/core-service.service";
import { StorageService } from "src/app/services/storage.service";
import { Result, parseError } from "src/app/shared/interfaces";
import { environment } from "src/environments/environment";

@Component({
    selector: 'app-informacion',
    templateUrl: 'informacion.component.html',
    styleUrl: 'informacion.component.scss'
})
export class InformacionComponent implements OnInit, OnDestroy {

    icons = freeSet;
    editor: Editor | any;
    editor3: Editor | any;
    editor4: Editor | any;
    html = '';
    html3 = '';
    html4 = '';

    private imagenUpload: File | any = null;
    public _image: string | any = '';
    private _url: string = '';
    private _imagenContenidoId = 6;
    private _imagenContenido = '';

    form = this.fb.group({
        contenido: this.fb.control('', Validators.required()),
        contenido3: this.fb.control('', Validators.required()),
        contenido4: this.fb.control('', Validators.required()),
    })
    private contenidoHtmlId = 2;
    private contenidoHtml3Id = 7;
    private contenidoHtml4Id = 8;
    private _modoEdicion: boolean = false;

    constructor(private api: ApiService, private storage: StorageService, private ntf: ToastService, private fb: FormBuilder, private core: CoreService) {
        this._modoEdicion = this.storage?.token?.logueado || false;
        this._url = environment.apiUrl;
    }

    ngOnInit(): void {
        this.obtenerContenido();
        this.editor = new Editor();
        this.editor3 = new Editor();
        this.editor4 = new Editor();

    }

    cambioImagen(event: any) {
        if (event.target.files && event.target.files[0]) {

            this.imagenUpload = event.target.files[0] || null;
            const reader = new FileReader();
            reader.onload = e => this._image = reader.result;
            reader.readAsDataURL(this.imagenUpload);
            this.uploadImage();
        }
    }

    async uploadImage() {
        try {
            this.core.lock()
            const file: File = this.imagenUpload;
            if (!isNil(file)) {
                const formData = new FormData();
                formData.append("file", file);
                const path = 'files/upload'
                const result = (await this.api.consulta(path, false, [], formData, 'POST', true)).data as Result
                this._imagenContenido = result.data.file;
                this.actualizarImagen();
            }
        } catch (e) {
            this.ntf.error(`Error: ${e}`)
        } finally {
            this.core.unlock()
        }
    }

    async actualizarImagen() {
        try {
            const path = `contenido/actualizar/${this._imagenContenidoId}`
            await this.api.consulta(path, true, [], { contenido: this._imagenContenido }, 'PUT')
            this.obtenerContenido();
            this.ntf.success(`Se actualizo la imagen.`)
        } catch (e) {
            this.ntf.error(`Error: ${parseError(e)}`);
        }
    }

    async obtenerContenido() {
        try {
            let path = `contenido/${this.contenidoHtmlId}`
            let result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this.form.patchValue({ contenido: result.data.contenido })
            this.html = result.data.contenido
            //Contenido 2
            path = `contenido/${this._imagenContenidoId}`
            result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this._imagenContenido = result.data.contenido;
            //Contenido 3
            path = `contenido/${this.contenidoHtml3Id}`
            result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this.form.patchValue({ contenido3: result.data.contenido })
            this.html3 = result.data.contenido
            //Contenido 4
            path = `contenido/${this.contenidoHtml4Id}`
            result = (await this.api.consulta(path, false, [], {}, 'GET')).data as Result
            this.form.patchValue({ contenido4: result.data.contenido })
            this.html4 = result.data.contenido;

            console.log(this.form.value);
        } catch (e) {

        }
    }

    async actualizarContenido() {
        try {

            let path = `contenido/actualizar/${this.contenidoHtmlId}`
            await this.api.consulta(path, true, [], { contenido: this.form.value.contenido }, 'PUT')

            path = `contenido/actualizar/${this.contenidoHtml3Id}`
            await this.api.consulta(path, true, [], { contenido: this.form.value.contenido3 }, 'PUT')

            path = `contenido/actualizar/${this.contenidoHtml4Id}`
            await this.api.consulta(path, true, [], { contenido: this.form.value.contenido4 }, 'PUT')

            this.obtenerContenido();
            this.ntf.success(`Se actualizo el contenido.`)
        } catch (e) {
            this.ntf.error(`Error: ${parseError(e)}`);
        }
    }

    // make sure to destory the editor
    ngOnDestroy(): void {
        this.editor.destroy();
        this.editor3.destroy();
        this.editor4.destroy();
    }

    get modoEdicion(): boolean {
        return this._modoEdicion;
    }

    get imagenContenido(): string {
        return `${this._url}/uploads/${this._imagenContenido}`;
    }

}